import { FuseAnimate, FusePageCarded } from "@fuse";
import _ from "@lodash";
import { TextField, Typography, withStyles, FormControl, FormControlLabel, Checkbox } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import LookupApp from "app/Core/Components/Lookup/LookupApp";
import PesquisaPainel from "app/Core/Components/PesquisaPainel/PesquisaPainel";
import TogglePesquisa from "app/Core/Components/PesquisaPainel/TogglePesquisa";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import withReducer from "app/store/withReducer";
import React from "react";
import { MdViewList } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import EmpresaGrupoProdutoDialog from "./EmpresaGrupoProdutoDialog";
import EmpresaGrupoProdutoList from "./EmpresaGrupoProdutoList";
import * as Actions from "./Store/Actions/EmpresaGrupoProdutoActions";
import reducer from "./Store/Reducers/EmpresaGrupoProdutoReducer";

const filtrosDisponiveis = [
    { "name": "nome", "label": "Nome", "value": "UPPER(pessoaformulario.formulario->>''nome'')", "tipo": "text" },
];

const styles = theme => ({
    addButton: {
        position: "absolute",
        right: 20,
        bottom: 20,
        zIndex: 99,
        color: theme.palette.text.primary,
    }
});

class EmpresaGrupoProdutoApp extends XAPPComponent {

    state = {
        acoes: null,
        showinativo: false,
    };

    componentWillUnmount() {
        const { isLookup, isButton } = this.props;
        if (!isLookup && !isButton) {
            this.props.clearReducer();
        }
    }

    getAcoes = () => {
        return this.state.acoes;
    };

    setAcoes = (_AValue) => {
        this.setState({ acoes: _AValue });
    };

    listFilter = (_AFilter, _ATarget = null, _APagina = 1, _ACallback = null) => {
        let { xappRouteParams } = this.props;
        const { target = null } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        this.props.list("SELECIONAR", xappRouteParams, _AFilter, _APagina, !_.isNull(_ATarget) ? _ATarget : target, _ACallback);
    };

    pesquisar = (_AUseFiltro = true) => {
        this.listFilter(this.getFiltro(_AUseFiltro));
        if (!_.isUndefined(this.PesquisaPainel)) {
            this.PesquisaPainel.togglePainel("empresagrupoproduto", _AUseFiltro ? this.getCountFiltro() : 0, this.clearFiltro);
        }
    };

    clearFiltro = () => {
        let form = {};
        filtrosDisponiveis.forEach(item => {
            form[item.name] = null;
        });
        form.showinativo = false;
        this.setState(_.set({ ...form }));
        this.pesquisar(false);
    };

    getFiltro = (_AUseFiltro = true) => {
        const form = this.state;
        var AArray = [];
        if (_AUseFiltro) {
            filtrosDisponiveis.forEach(item => {
                if (!_.isUndefined(form[item.name]) && !_.isNull(form[item.name]) && form[item.name].length > 0) {
                    AArray.push({ Campo: item.value, Operador: (item.tipo === "text" ? "LIKE" : "="), Valor: form[item.name] });
                }
            });
            if (form.showinativo) {
                AArray.push({ "Campo": "pessoaformulario.statusregistro", "Operador": ">", "Valor": -5 });
            }
        }
        return { AND: AArray };
    };

    handleChange = (ev) => {
        this.setState(_.set({ ...this.state }, ev.target.name, ev.target.type === "checkbox" ? ev.target.checked : ev.target.value));
    };

    getCountFiltro = () => {
        const form = this.state;
        var AResult = 0;
        filtrosDisponiveis.forEach(item => {
            if (!_.isUndefined(form[item.name]) && !_.isNull(form[item.name]) && form[item.name].length > 0) {
                AResult++;
            }
        });
        if (form.showinativo) {
            AResult++;
        }
        return AResult;
    };

    renderListagem() {
        const { classes, isLookup, onChange, filter, isButton } = this.props;
        const xappRouteParams = this.props.match.params;
        const form = this.state;

        return (
            <React.Fragment>
                <PesquisaPainel
                    id="empresagrupoproduto"
                    anchor="left"
                    onRef={instance => this.PesquisaPainel = instance}
                >
                    <div className={"flex flex-col p-12 text-center items-center"}>
                        {_.uniqBy(filtrosDisponiveis, "name").map(item => (
                            <TextField
                                className="mb-12"
                                key={item.name}
                                id={item.name}
                                name={item.name}
                                label={item.label}
                                value={!_.isNull(form[item.name]) ? form[item.name] : ""}
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                type={item.tipo}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        ))}
                        <FormControl className={"w-full"}>
                            <FormControlLabel
                                className={"mx-0"}
                                control={
                                    <Checkbox
                                        className="p-6 mr-8"
                                        name={"showinativo"}
                                        type='checkbox'
                                        checked={form.showinativo}
                                        onChange={this.handleChange}
                                    />
                                }
                                label={"Mostrar inativos"}
                            />
                        </FormControl>
                    </div>
                    <div className="flex p-12 gap-6">
                        <div className="flex-1" />
                        <XAPPButton
                            className="text-white"
                            label="Limpar"
                            type="Button"
                            variant="contained"
                            color="primary"
                            icon="close"
                            iconProps="text-20 mr-8"
                            onClick={() => this.clearFiltro()}
                        />
                        <XAPPButton
                            className="text-white"
                            label="Pesquisar"
                            type="Button"
                            variant="contained"
                            color="primary"
                            icon="search"
                            iconProps="text-20 mr-8"
                            onClick={() => this.pesquisar()}
                        />
                    </div>
                </PesquisaPainel>
                <CatchErro
                    url={this.props.match.url}
                >
                    <FusePageCarded
                        classes={{
                            contentWrapper: "p-0",
                            contentCardWrapper: "p-16 sm:p-24 pb-80",
                            leftSidebar: "w-256 border-0",
                            header: "w-full min-h-48 h-48 max-h-48 flex",
                            topBg: "min-h-48 h-48"
                        }}
                        header={
                            <div className="w-full flex items-center">
                                <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                    <Typography className="flex text-white items-center" variant="h6">
                                        <MdViewList className="text-24 text-white mx-8" />
                                        {"Grupos de serviços"}
                                    </Typography>
                                </FuseAnimate>
                                <div className="flex-1" />
                                <TogglePesquisa id={"empresagrupoproduto"} />
                            </div>
                        }
                        content={
                            !isButton ?
                                <EmpresaGrupoProdutoList
                                    isLookup={isLookup}
                                    onChange={onChange}
                                    filter={filter}
                                    xappRouteParams={xappRouteParams}
                                    setAcoes={this.setAcoes}
                                    getAcoes={this.getAcoes}
                                    listFilter={this.listFilter}
                                />
                                :
                                <div />
                        }
                        sidebarInner
                        onRef={instance => {
                            this.pageLayout = instance;
                        }}
                        innerScroll
                    />
                    {!isButton && !isLookup &&
                        <XAPPButton
                            id={"fab-add-grupo-produto"}
                            className={classes.addButton}
                            type="Fab"
                            variant="contained"
                            color="primary"
                            iconProps="text-24 text-white"
                            onClick={() => { this.props.openNewDialog(); }}
                            icon={"add"}
                        />
                    }
                </CatchErro>
            </React.Fragment>
        );
    }

    renderLookup() {
        const { multiSelect, autoSearch, selectFirstAuto, openNewDialog, onChange, label = null, required, Contas, selected, className, id, readOnly, campoid = null, camponome = null } = this.props;
        var { xappRouteParams } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        return (
            <React.Fragment>
                <LookupApp
                    className={className}
                    label={label}
                    id={id}
                    multiSelect={multiSelect}
                    onChange={onChange}
                    required={required}
                    options={!_.isNull(Contas) ? Contas : []}
                    selected={selected}
                    listagem={this.renderListagem()}
                    pesquisar={this.listFilter}
                    xappRouteParams={xappRouteParams}
                    campoid={!_.isNull(campoid) ? campoid : "idpessoaformulario"}
                    camponome={!_.isNull(camponome) ? camponome : "nome"}
                    filtrodescricao={"UPPER(pessoaformulario.formulario->>''nome'')"}
                    novo={openNewDialog}
                    readOnly={readOnly}
                    autoSearch={autoSearch}
                    selectFirstAuto={selectFirstAuto}
                    target="spvwempresagrupoprodutolookup"
                />
            </React.Fragment>
        );
    }

    render() {
        const { isLookup } = this.props;

        var { xappRouteParams } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    {isLookup ?
                        <React.Fragment>
                            {this.renderLookup()}
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {this.renderListagem()}
                        </React.Fragment>
                    }
                    <EmpresaGrupoProdutoDialog
                        xappRouteParams={xappRouteParams}
                        callback={() => this.listFilter(this.getFiltro())}
                    />
                </CatchErro>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        clearReducer: Actions.clearReducer,
        list: Actions.list,
        openNewDialog: Actions.openNewDialog
    }, dispatch);
}

function mapStateToProps({ EmpresaGrupoProduto }) {
    return {
        Contas: EmpresaGrupoProduto.data,
    };
}

export default withReducer("EmpresaGrupoProduto", reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaGrupoProdutoApp))));
